<template>
  <div class="role-wrap">
    <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增角色</el-button>

    <!-- 角色列表表格 -->
    <el-table :data="tableData" border class="mt-20" style="width: 100%">
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="roleName" label="角色名称" align="center" />
      <el-table-column prop="roleCode" label="角色编码" align="center" />
      <el-table-column prop="platform" label="所属平台" align="center" />
      <el-table-column prop="remark" label="备注" align="center" />
      <el-table-column prop="createTime" label="创建时间" align="center" />
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="props">
          <el-button type="text" icon="el-icon-edit" @click="openEditDialog(props.row)">编辑</el-button>
          <el-button type="text" icon="el-icon-delete" @click="handleDelete(props.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑弹窗 -->
    <el-dialog title="角色信息" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="角色名称">
          <el-input v-model="form.roleName"></el-input>
        </el-form-item>
        <el-form-item label="角色编码">
          <el-input v-model="form.roleCode"></el-input>
        </el-form-item>
        <el-form-item label="所属平台">
          <el-radio-group v-model="form.platform">
            <el-radio label="中台"></el-radio>
            <el-radio label="学校"></el-radio>
            <el-radio label="教育局"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getRoleList, addRole, updateRole, delRole } from './memu.js'
export default {
  name: 'RoleTable',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      form: {
        id: null,
        roleName: '',
        roleCode: '',
        platform: '中台',
        remark: ''
      },
	  platform:'',
    }
  },
  mounted() {
    this.loadTableData()
  },
  methods: {
    async loadTableData() {
      const res = await getRoleList(this.platform)
      this.tableData = res.data.data
    },
    openAddDialog() {
      this.dialogVisible = true
      this.form = { id: null, roleName: '', roleCode: '', platform: '中台', remark: '' }
    },
    openEditDialog(row) {
      this.dialogVisible = true
      this.form = { ...row }
    },
    async submitForm() {
      try {
        if (this.form.id) {
          await updateRole(this.form)
          this.$message.success('编辑成功')
        } else {
          await addRole(this.form)
          this.$message.success('新增成功')
        }
        this.dialogVisible = false
        this.loadTableData()
      } catch (e) {
        this.$message.error('操作失败')
      }
    },
    handleDelete(row) {
      this.$confirm('删除角色会清空对应菜单权限，是否继续？', '警告', { type: 'warning' })
        .then(async () => {
          await delRole(row.id)
          this.$message.success('删除成功')
          this.loadTableData()
        })
    }
  }
}
</script>

<style scoped>
.mt-20 {
  margin-top: 20px;
}
</style>